import { motion } from "framer-motion";
import { useSiteContent } from "@/context/SiteContent";

const EASE = [0.16, 1, 0.3, 1];

// Zentrale Botschaft des Studios — direkt nach der Hero-Experience
export default function BrandStatement() {
  const { content } = useSiteContent();
  const t = content.texts || {};
  const lines = [t.claim_1 || "Deine Idee.", t.claim_2 || "Unsere Umsetzung.", t.claim_3 || "Dein Ergebnis."];
  return (
    <section className="px-6 lg:px-12 py-24 md:py-36 max-w-[1600px] mx-auto" data-testid="brand-statement">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "100px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="text-xs uppercase tracking-[0.35em] text-gold font-bold mb-8"
      >
        Justin Web Design &amp; Clothing
      </motion.p>
      <h2 className="font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-6xl lg:text-8xl">
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span
              className={`block ${i === 1 ? "font-editorial italic normal-case tracking-normal text-gold" : ""}`}
              initial={{ y: "110%" }}
              whileInView={{ y: "0%" }}
              viewport={{ once: true, margin: "80px" }}
              transition={{ duration: 1, ease: EASE, delay: 0.12 * i }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "80px" }}
        transition={{ duration: 0.7, ease: EASE, delay: 0.45 }}
        className="mt-10 text-base md:text-lg leading-relaxed text-zinc-500 max-w-2xl"
      >
        Kein Baukasten, keine Templates. Eine Idee wird gemeinsam entwickelt und Schritt
        für Schritt zu einem fertigen digitalen oder physischen Produkt — vom ersten
        Strich bis zum verkaufsfertigen Online-Shop.
      </motion.p>
    </section>
  );
}
